<template>
<router-view />
</template>

<script>
export default {
  name: 'DataAudit',
  routeInfo: {
    label: '数据审核'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/02Data-Audit/index.vue